import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useGetSubBrandCode} from '@vio/core/src/_web/brand/hooks/useGetSubBrandCode'
// eslint-disable-next-line -- Used as fallback when offer data is not available
import {defaultBrand} from '@vio/core/src/brand/config'
import {ProviderLogo} from '@vio/shared/src/search/ProviderLogo'

export const PrimaryRoomOfferLogo = () => {
  const {brand} = useBrand()
  const {
    commerce: {bookOnBrand}
  } = useBrandCapabilities()
  const isBookOnBrand = bookOnBrand.enabled
  const subBrandCode = useGetSubBrandCode()

  const displayProviderCode = isBookOnBrand
    ? subBrandCode || brand.providerCode
    : defaultBrand.providerCode

  return (
    <Box paddingTop="s250" paddingBottom="s200">
      <ProviderLogo providerCode={displayProviderCode} height={20} />
    </Box>
  )
}
